import { useContext, useEffect } from "react";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { ConfigurationItem, FormTrailingStopData } from "@shared/types";
import { getParsedTrailingStopFromConfiguration } from "@shared/features/bots/utils";

const useTrailingStop = (modifiedConfiguration?: ConfigurationItem) => {
  const { setTrailingStop } = useContext(TradingTerminalContext)!;

  const getDefaultTrailingStop = () => {
    return getParsedTrailingStopFromConfiguration(modifiedConfiguration);
  };

  const initializeTrailingStopData = () => {
    if (modifiedConfiguration && Object.keys(modifiedConfiguration).length) {
      setTrailingStop(getDefaultTrailingStop() as FormTrailingStopData<number>);
    }
  };

  useEffect(() => {
    initializeTrailingStopData();
  }, [modifiedConfiguration]);
};

export default useTrailingStop;
